import type { PqcInventorySummary, SbomInventorySummary } from "../../api/types.js";

export const SBOM_UPGRADE_OPTION_COPY =
  "Unknown from static source. This snapshot does not resolve a later version or patched replacement.";

export const CBOM_CERTIFICATE_IDENTITY_COPY =
  "None observed in static source. Certificate subject, issuer, and serial are not inferred from algorithm APIs.";

export const CBOM_KEY_STORAGE_COPY =
  "Unknown from static source. Keystore, HSM, and file-backed key material are not proven by this observation.";

export function sbomDependencyPathCopy(row: SbomInventorySummary["rows"][number]): string {
  if (row.replacedFrom) {
    return `Replacement of ${row.replacedFrom} declared in ${row.manifestPath}`;
  }
  if (row.dependencyPath.length === 0) {
    return `Direct identity in ${row.manifestPath}. Nested lockfile graph path is not stored on this inventory row.`;
  }
  if (row.dependencyPath.length === 1) {
    return `Direct identity ${row.dependencyPath[0]} in ${row.manifestPath}`;
  }
  return `Nested lockfile path ${row.dependencyPath.join(" → ")} in ${row.manifestPath}`;
}

export function cbomProtocolRoleCopy(row: PqcInventorySummary["rows"][number]): string {
  return row.useContext.replaceAll("_", " ");
}
